// extracted by mini-css-extract-plugin
export var chevron = "_jb-3";
export var chevronRotated = "_jb-4";
export var image = "_jb-1";
export var imageContainer = "_jb-0";
export var shippingAddress = "_jb-2";